/**
 * Table Section component themable props.
 * Section components can be Footer (tfoot), Header (thead) or Body (tbody) and currently share the same themable props
 */
import { stringLiteralArray } from "../utils"

export default {
  appearances: stringLiteralArray(["compact", "default", "ghosted"])
}
